<template>
  <CModal :title="title" :show.sync="show" color="success">
    <image-uploader @success="success" />
    <template #header>
      <h6 class="modal-title">{{ title }}</h6>
      <CButtonClose @click="show = false" class="text-white" />
    </template>
    <template #footer>
      <CButton @click="doCancel" color="danger">Batal</CButton>
      <CButton @click="doOke" color="success">Oke</CButton>
    </template>
  </CModal>
</template>
<script>
import ImageUploader from "./ImageUploader.vue";
export default {
  components: { ImageUploader },
  props: ["show", "title"],
  data() {
    return {
      data: {},
    };
  },
  methods: {
    success(data) {
      this.data = data;
    },
    doOke() {
      this.$emit("success", this.data);
    },
    doCancel() {
      this.$emit("cancel");
    },
  },
};
</script>